import { KeycloakInitOptions } from 'keycloak-js';
import { IKeycloakProviderState } from './types';

const defaultKeycloakProviderState: IKeycloakProviderState<any> = {
  initialized: false,
  isAuthenticated: false,
  isLoading: true,
  authClient: {},
  selectedCustomerId: null,
  onSelectCustomerId: () => {},
};

const defaultInitOptions: KeycloakInitOptions = {
  onLoad: 'login-required',
  checkLoginIframe: false,
  pkceMethod: 'S256',
};

export { defaultKeycloakProviderState, defaultInitOptions };
